import React from 'react';

const BinIcon: React.FC<{ size?: number; color?: string; style?: React.CSSProperties }> = ({
  size = 24,
  color = 'currentColor',
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    style={{ display: 'inline-block', ...style }}
  >
    <path d="M9 3v1H4v2h16V4h-5V3H9zm-4 5v13c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8H5zm4 2h2v8H9v-8zm4 0h2v8h-2v-8z" />
  </svg>
);

export default BinIcon;
